export const SITE = {
  name: "Mountain Nest",
  tagline: "Luxury Balinese Villa at Nandi Hills",
  description:
    "A luxury 5-bedroom Balinese villa at Nandi Foothills, Karnataka. Swimming pool with 12 jacuzzi points, sky deck, dance floor & 2790 sq ft of premium living.",
  url: process.env.NEXT_PUBLIC_SITE_URL || "https://ournestvillas.com",
  airbnbUrl: "https://airbnb.co.in/h/mountainnestvilla",
  phone: "+91 98865 01846",
  email: "reservations@ournestvillas.com",
  address: "Nandi Foothills, Chikkaballapur District, Karnataka, India",
  coordinates: { lat: 13.3702, lng: 77.6835 },
  checkInTime: "14:00",
  checkOutTime: "11:00",
  maxGuests: 15,
  bedrooms: 5,
  bathrooms: 5,
  sqft: 2790,
  floors: 3,
  builtYear: 2021,
  basePricePerNight: 30000,
} as const;

export const AMENITIES = [
  { icon: "Waves", label: "Swimming Pool", detail: "12 Jacuzzi Points" },
  { icon: "Sunset", label: "Sky Deck", detail: "Panoramic Hill Views" },
  { icon: "Music", label: "Dance Floor", detail: "Pro Audio & Lights" },
  { icon: "Gamepad2", label: "Games Zone", detail: "TT, Foosball, Darts" },
  { icon: "Utensils", label: "Kitchen", detail: "Fully Equipped" },
  { icon: "Car", label: "Parking", detail: "10 Cars" },
  { icon: "Wind", label: "Air Conditioning", detail: "9 Units" },
  { icon: "Wifi", label: "Wi-Fi", detail: "High Speed" },
  { icon: "Droplets", label: "Hot Water", detail: "24/7" },
  { icon: "ShieldCheck", label: "Security", detail: "Gated & Fenced" },
  { icon: "Trees", label: "Garden", detail: "Landscaped" },
  { icon: "Briefcase", label: "Conference Room", detail: "Open-Air" },
] as const;

export const PROPERTY_SECTIONS = [
  { id: "living-room", label: "Living Room" },
  { id: "bedrooms", label: "Bedrooms" },
  { id: "swimming-pool", label: "Swimming Pool" },
  { id: "sky-deck", label: "Sky Deck" },
  { id: "dance-floor", label: "Dance Floor" },
  { id: "dining", label: "Dining" },
  { id: "games-zone", label: "Games Zone" },
  { id: "bathrooms", label: "Bathrooms" },
  { id: "interiors", label: "Interiors" },
  { id: "outdoors", label: "Outdoors" },
] as const;

export const GALLERY_IMAGES: Record<string, { src: string; alt: string }[]> = {
  "living-room": [
    { src: "/images/living-room-daytime.jpg", alt: "Living room with cream sofas and marble table" },
    { src: "/images/living-room-kitchen-view.jpg", alt: "Living room with kitchen view and laterite walls" },
    { src: "/images/living1.jpg", alt: "Living room with Balinese interiors" },
    { src: "/images/living2.jpg", alt: "Spacious living area" },
    { src: "/images/living3.jpg", alt: "Living room seating" },
  ],
  "bedrooms": [
    { src: "/images/bedroom1.jpg", alt: "Luxury bedroom with hill view" },
    { src: "/images/bedroom2.jpg", alt: "Air-conditioned bedroom" },
    { src: "/images/bedroom3.jpg", alt: "Spacious villa bedroom" },
  ],
  "swimming-pool": [
    { src: "/images/swimming-pool-night.jpg", alt: "Swimming pool with waterfall at night" },
    { src: "/images/pool-party-friends.jpg", alt: "Pool party with friends" },
  ],
  "sky-deck": [
    { src: "/images/skydeck-lounge-wicker.jpg", alt: "Sky deck lounge with wicker furniture" },
    { src: "/images/skydeck-lounge-wide.jpg", alt: "Sky deck lounge wide view" },
    { src: "/images/skydeck-nandi-hills-view.jpg", alt: "Sky deck terrace with Nandi Hills view" },
    { src: "/images/champagne-cheers-hills.jpg", alt: "Champagne cheers with hills backdrop" },
    { src: "/images/sunset-drinks-skydeck.jpg", alt: "Sunset drinks on sky deck" },
    { src: "/images/bar1.jpg", alt: "Bar counter with dance floor entrance" },
    { src: "/images/bar2.jpg", alt: "Sky deck lounge daytime" },
    { src: "/images/bar3.jpg", alt: "Sky deck bar counter" },
  ],
  "dance-floor": [
    { src: "/images/dance-floor-entrance.jpg", alt: "Dance floor entrance with neon sign" },
    { src: "/images/dance-floor-entrance-wide.jpg", alt: "Dance floor entrance wide view" },
    { src: "/images/funzone1.jpg", alt: "Dance floor with neon lights" },
    { src: "/images/funzone2.jpg", alt: "Dance floor with disco lights" },
  ],
  "dining": [
    { src: "/images/dining-table-setup.jpg", alt: "Dining table setup" },
    { src: "/images/dining-laterite-wall.jpg", alt: "Dining area with laterite wall" },
    { src: "/images/dining-full-view.jpg", alt: "Dining room full view" },
    { src: "/images/dining1.jpg", alt: "Dining room" },
    { src: "/images/dining2.jpg", alt: "Dining area" },
  ],
  "games-zone": [
    { src: "/images/conference-room-aerial.jpg", alt: "Conference room aerial view" },
    { src: "/images/work1.jpg", alt: "Games zone with board games" },
    { src: "/images/work2.jpg", alt: "Table tennis, foosball and darts" },
    { src: "/images/gaming_gallery.jpg", alt: "Games and activity zone" },
  ],
  "bathrooms": [
    { src: "/images/bathroom1.jpg", alt: "Modern bathroom" },
    { src: "/images/bathroom2.jpg", alt: "Bathroom with hot water" },
    { src: "/images/bathroom3.jpg", alt: "Premium bathroom fittings" },
  ],
  "interiors": [
    { src: "/images/ground-floor-seating.jpg", alt: "Ground floor designer seating" },
    { src: "/images/interior1.jpg", alt: "Backlit Buddha sculpture" },
    { src: "/images/interior2.jpg", alt: "Tree of life sculpture" },
    { src: "/images/interior3.jpg", alt: "Living and dining room at night" },
  ],
  "outdoors": [
    { src: "/images/romantic-rose-petals.jpg", alt: "Romantic rose petal decoration" },
    { src: "/images/entrance.jpg", alt: "Villa entrance gate" },
    { src: "/images/exterior3.jpg", alt: "Mountain Nest name board" },
    { src: "/images/property.jpg", alt: "Full property view" },
    { src: "/images/exterior1.jpg", alt: "Villa with Nandi Hills" },
  ],
};

export const HERO_IMAGES = [
  { src: "/images/hero.jpg", alt: "Mountain Nest Villa exterior with hills" },
  { src: "/images/hero2.jpg", alt: "Mountain Nest building front view" },
  { src: "/images/swimming-pool-night.jpg", alt: "Swimming pool with waterfall" },
  { src: "/images/skydeck-lounge-wicker.jpg", alt: "Sky deck lounge" },
  { src: "/images/living-room-daytime.jpg", alt: "Luxury living room" },
];

export const REVIEWS = [
  {
    name: "Priya S.",
    rating: 5,
    text: "Absolutely stunning villa! The pool with jacuzzi was the highlight. The sky deck views of Nandi Hills are breathtaking. Will definitely return.",
    source: "airbnb" as const,
    date: "Jan 2026",
  },
  {
    name: "Rahul M.",
    rating: 5,
    text: "Perfect for our corporate retreat. The conference room, games zone, and dance floor kept everyone entertained. Highly recommended!",
    source: "google" as const,
    date: "Dec 2025",
  },
  {
    name: "Ananya K.",
    rating: 5,
    text: "We celebrated our anniversary here. The romantic setup with rose petals was magical. The Balinese interiors are gorgeous.",
    source: "airbnb" as const,
    date: "Nov 2025",
  },
  {
    name: "Vikram D.",
    rating: 5,
    text: "Best villa near Bangalore, hands down. 5 bedrooms, pool, dance floor — everything you need for a perfect getaway with friends.",
    source: "google" as const,
    date: "Oct 2025",
  },
];
